import { useEffect } from "react";

/**
 * Protection basique et globale de toutes les images du site :
 * - menu contextuel (clic droit / appui long) bloqué sur les <img>
 * - glisser-déposer désactivé
 * Appliqué au niveau du document : toute image ajoutée à l'avenir est couverte
 * automatiquement, sans modification par image.
 */
export function useImageProtection() {
  useEffect(() => {
    const isImage = (target: EventTarget | null) =>
      target instanceof Element && target.closest("img, picture") !== null;

    const onContextMenu = (e: MouseEvent) => {
      if (isImage(e.target)) e.preventDefault();
    };
    const onDragStart = (e: DragEvent) => {
      if (isImage(e.target)) e.preventDefault();
    };

    document.addEventListener("contextmenu", onContextMenu);
    document.addEventListener("dragstart", onDragStart);
    return () => {
      document.removeEventListener("contextmenu", onContextMenu);
      document.removeEventListener("dragstart", onDragStart);
    };
  }, []);
}
